import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "autocomplete-cidade" }
const _hoisted_2 = ["value", "placeholder", "readonly"]
const _hoisted_3 = {
  key: 0,
  class: "suggestions-list"
}
const _hoisted_4 = ["onMousedown", "onMouseenter"]
const _hoisted_5 = { class: "city-uf" }

import { ref, computed, watch, reactive, onMounted } from 'vue';
import * as clienteService from '@/services/clientesService';

interface Props {
  modelValue?: number | null,
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoCompleteClientes',
  props: {
    modelValue: {},
    placeholder: { default: 'Digite o nome do cliente' }
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const query = ref("")
const showSuggestions = ref(false)
const highlightedIndex = ref(-1)
const selecionados = ref<clienteService.Cliente | null>(null)

var controle = reactive({
  itens: [] as clienteService.Cliente[],
  text: "",
  status: "",
  pesquisando: false,
})

onMounted(() => {
  buscar()
})

const filtrados = computed(() => {
  const q = String(query.value).trim().toLowerCase()
  if (!q) return []


  var r = controle.itens?.filter(item =>
    item.nome.toLowerCase().includes(q) ||
    item.cpf?.toLowerCase().includes(q)
  );

  return r;
})

const placeHolder = computed(() => {
  if (controle.pesquisando) {
    return "Buscando clientes..."
  }

  return props.placeholder
})

// Computed para exibir o texto no input
const displayText = computed(() => {
  if (selecionados.value) {
    return `${selecionados.value.nome} - ${selecionados.value.cpf}`
  }
  return query.value
})

function onInput() {
  // Limpar cidade selecionada quando o usuário digitar
  if (selecionados.value) {
    selecionados.value = null
    emit('update:modelValue', undefined)
  }

  showSuggestions.value = true
  highlightedIndex.value = -1
}

function seleciona(item: clienteService.Cliente) {
  selecionados.value = item
  query.value = "" // Limpar query para não interferir no displayText
  showSuggestions.value = false
  highlightedIndex.value = -1

  emit('update:modelValue', item.clienteId)
  emit('selected', item)
}

function hideSuggestions() {
  // Delay to allow click event on suggestion
  setTimeout(() => {
    showSuggestions.value = false
    highlightedIndex.value = -1
  }, 150)
}

function handleKeyDown(event: KeyboardEvent) {
  if (!showSuggestions.value || !filtrados.value.length) return

  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault()
      highlightedIndex.value = Math.min(
        highlightedIndex.value + 1,
        filtrados.value.length - 1
      )
      break

    case 'ArrowUp':
      event.preventDefault()
      highlightedIndex.value = Math.max(highlightedIndex.value - 1, 0)
      break

    case 'Enter':
      event.preventDefault()
      if (highlightedIndex.value >= 0 && highlightedIndex.value < filtrados.value.length) {
        seleciona(filtrados.value[highlightedIndex.value])
      }
      break

    case 'Escape':
      event.preventDefault()
      showSuggestions.value = false
      highlightedIndex.value = -1
      break
  }
}

// Watch para sincronizar com modelValue externo
watch(() => props.modelValue, (newValue) => {
  console.log("modelValue mudou para:", newValue);
  if (newValue && controle.itens.length > 0) {
    // Buscar o cliente pelo ID
    const cliente = controle.itens.find(c => c.clienteId === newValue)
    if (cliente) {
      selecionados.value = cliente
      query.value = ""
    }
  } else if (!newValue) {
    selecionados.value = null
    query.value = ""
  }
})

// Watch para buscar cliente quando o modelValue muda e ainda não temos os clientes
watch(() => controle.itens, (clientes) => {
  if (props.modelValue && clientes.length > 0) {
    const cliente = clientes.find(c => c.clienteId === props.modelValue)
    if (cliente) {
      selecionados.value = cliente
      query.value = ""
    }
  }
})

// Reset highlighted index when filtered cities change
watch(filtrados, () => {
  highlightedIndex.value = -1
})

function buscar() {
  controle.status = "Buscando clientes...";
  controle.pesquisando = true;

  clienteService.obter({ tamanhoPagina: 6000 }).then(response => {
    controle.itens = response.dados || [];
    controle.status = "";
    controle.pesquisando = false;
  }).catch(error => {
    console.error("Erro ao buscar clientes:", error);
    controle.status = `Erro ${error.message}`;
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      value: displayText.value,
      onInput: _cache[0] || (_cache[0] = (e) => { query.value = (e.target as HTMLInputElement).value; onInput(); }),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (showSuggestions.value = true)),
      onBlur: hideSuggestions,
      onKeydown: handleKeyDown,
      placeholder: placeHolder.value,
      class: "autocomplete-input form-control form-control-sm",
      readonly: _unref(controle).pesquisando == true 
    }, null, 40, _hoisted_2),
    (showSuggestions.value && filtrados.value.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtrados.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.clienteId,
              onMousedown: _withModifiers(($event: any) => (seleciona(item)), ["prevent"]),
              onMouseenter: ($event: any) => (highlightedIndex.value = index),
              class: _normalizeClass({
          'suggestion-item': true,
          'highlighted': index === highlightedIndex.value
        })
            }, [
              _createElementVNode("strong", null, _toDisplayString(item.nome), 1),
              _createElementVNode("span", _hoisted_5, " - " + _toDisplayString(item.cpf), 1)
            ], 42, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})